export { default as TrendingDownSolidIcon } from './TrendingDownSolidIcon';
